export const navLinks = [
  { id: 'about', label: '平台简介' },
  { id: 'entry', label: '官方入口' },
  { id: 'features', label: '功能介绍' },
  { id: 'download', label: '下载方式' },
  { id: 'guide', label: '使用指南' },
  { id: 'safety', label: '安全提示' },
  { id: 'faq', label: '常见问题' },
];

export const heroStats = [
  { value: '3 类', label: '入口渠道' },
  { value: '8 条', label: '常见问题' },
  { value: '持续', label: '地址关注' },
];

export const aboutPoints = [
  {
    icon: 'ri-compass-3-line',
    title: '入口一处查清',
    desc: '把官方平台入口、最新地址与 App 下载方式整理在同一页，减少在多个来源之间来回比对的时间。',
  },
  {
    icon: 'ri-shield-check-line',
    title: '先辨别再使用',
    desc: '不仅告诉你大概去哪找，也会说明如何判断一个页面是不是官方渠道，避免误入仿冒站点。',
  },
  {
    icon: 'ri-refresh-line',
    title: '信息定期复核',
    desc: '入口变动、页面打不开是常见情况，本站会持续关注官方公告，并在更新记录里标注变化时间。',
  },
];

export const entryCards = [
  {
    id: 'official',
    icon: 'ri-global-line',
    title: '官方平台入口',
    tag: '主入口',
    desc: '访问官方平台是观看与使用服务最稳妥的方式。请优先通过官方公告、官方客户端内跳转等可信渠道确认入口，不要轻信来源不明的第三方链接。',
    points: ['优先使用官方发布渠道获取', '页面会展示平台标识与备案信息', '登录、下载均在平台内完成'],
  },
  {
    id: 'latest',
    icon: 'ri-link',
    title: '最新地址',
    tag: '地址变动',
    desc: '当原有页面打不开时，通常意味着地址发生了调整。建议先稍等片刻刷新，若仍无法访问，再到官方公告或本页更新记录中核对当前有效地址。',
    points: ['打不开时先刷新并更换网络尝试', '以官方公告中的地址为准', '本页更新记录会标注复核时间'],
  },
  {
    id: 'app',
    icon: 'ri-smartphone-line',
    title: 'App 下载',
    tag: '移动端',
    desc: '移动端使用建议通过官方应用商店搜索或官方页面提供的下载入口获取安装包，安装前确认开发者信息与所需权限是否合理。',
    points: ['优先通过官方应用商店获取', '安装前核对开发者与权限', '不安装来历不明的安装包'],
  },
];

export const features = [
  {
    icon: 'ri-translate-2',
    title: '多语言字幕切换',
    desc: '同一内容可搭配多种语言字幕，支持一键切换与关闭，方便不同语言习惯的用户对照观看。',
    group: '字幕',
  },
  {
    icon: 'ri-font-size-2',
    title: '字幕样式自定义',
    desc: '字幕字号、颜色、描边与显示位置可按个人习惯调整，小屏设备上也能看清每一行。',
    group: '字幕',
  },
  {
    icon: 'ri-timer-flash-line',
    title: '字幕与音画同步',
    desc: '支持手动微调字幕前后偏移，遇到轻微不同步时无需等待修复，自己就能快速对齐。',
    group: '字幕',
  },
  {
    icon: 'ri-hd-line',
    title: '多清晰度播放',
    desc: '根据网络情况在流畅、高清等档位之间切换，兼顾画质与流畅度，减少卡顿等待。',
    group: '播放',
  },
  {
    icon: 'ri-speed-up-line',
    title: '倍速与快捷手势',
    desc: '支持多档倍速播放，以及音量、亮度、进度的手势操作，观看效率更高。',
    group: '播放',
  },
  {
    icon: 'ri-download-cloud-2-line',
    title: '离线缓存观看',
    desc: '在有网络时提前缓存内容，通勤、出行等弱网场景下也能继续观看。',
    group: '播放',
  },
  {
    icon: 'ri-device-line',
    title: '多端进度同步',
    desc: '登录同一账号后，手机、平板与电脑之间的观看进度可衔接，随时接着上次继续。',
    group: '同步',
  },
  {
    icon: 'ri-history-line',
    title: '观看记录管理',
    desc: '自动记录最近观看内容，支持快速续播与清理记录，个人列表始终保持整洁。',
    group: '同步',
  },
];

export const featureGroups = [
  { id: 'all', label: '全部' },
  { id: '字幕', label: '字幕能力' },
  { id: '播放', label: '播放体验' },
  { id: '同步', label: '账号与同步' },
];

export const downloadPlatforms = [
  {
    id: 'android',
    name: 'Android 安卓',
    icon: 'ri-android-line',
    summary: '适合绝大多数安卓手机与平板，通过官方渠道获取安装包后即可安装使用。',
    steps: [
      '打开官方页面或官方应用商店，搜索平台名称确认开发者信息。',
      '核对应用图标、名称与权限申请是否合理后再下载。',
      '安装完成后首次打开需授予存储、网络等必要权限。',
    ],
    note: '若系统提示「未知来源应用」，请在系统设置中确认该来源可信后再允许安装。',
  },
  {
    id: 'ios',
    name: 'iPhone / iPad',
    icon: 'ri-apple-line',
    summary: '通过 App Store 获取，下载与更新都由系统统一管理，相对更省心。',
    steps: [
      '在 App Store 中搜索平台名称，优先选择官方开发者发布的应用。',
      '核对评分、更新记录与开发者名称，避免同名仿冒应用。',
      '下载后可使用系统账号完成更新与权限管理。',
    ],
    note: '若在商店中暂未搜到，可能是版本调整或上架状态变化，可先使用网页版。',
  },
  {
    id: 'desktop',
    name: '电脑 / 网页端',
    icon: 'ri-computer-line',
    summary: '不想安装客户端时，可直接通过浏览器访问平台网页版，功能同样完整。',
    steps: [
      '使用较新版本的浏览器打开平台入口。',
      '如需更稳定的体验，可按官方指引安装桌面客户端。',
      '登录账号后即可同步手机端的观看进度与记录。',
    ],
    note: '网页端建议开启浏览器的硬件加速，以获得更流畅的播放效果。',
  },
];

export const guideSteps = [
  {
    step: '01',
    title: '确认入口是否可信',
    desc: '先通过官方公告、官方客户端内跳转等方式核对当前入口，不要直接点击来源不明的短链或广告。',
  },
  {
    step: '02',
    title: '打开平台并完成访问',
    desc: '进入平台后如遇打不开，可先刷新、更换网络环境或稍后再试，多数情况下属于临时性访问波动。',
  },
  {
    step: '03',
    title: '按需选择观看或下载',
    desc: '想在线观看直接选择内容播放；想长期使用则按设备在下载页获取对应客户端安装包。',
  },
  {
    step: '04',
    title: '开启并调整字幕',
    desc: '播放时打开字幕功能，按需切换语言、调整字号与位置，必要时微调字幕同步偏移。',
  },
];

export const safetyTips = [
  {
    icon: 'ri-arrow-right-circle-line',
    title: '只从官方渠道获取入口',
    desc: '官方公告与官方客户端内跳转是最可靠的来源，第三方聚合页面仅供参考，最终以官方发布为准。',
  },
  {
    icon: 'ri-error-warning-line',
    title: '警惕要求付费解锁的页面',
    desc: '如果页面以「付费才能观看」「充值解锁」等方式施压，且与官方说明不一致，请立即停止操作。',
  },
  {
    icon: 'ri-file-shield-2-line',
    title: '谨慎安装未知安装包',
    desc: '来源不明的安装包可能携带风险，安装前核对开发者、文件大小与权限请求是否合理。',
  },
  {
    icon: 'ri-lock-password-line',
    title: '不在仿冒页面输入账号',
    desc: '登录前确认页面地址与官方一致，仿冒页面常以相似域名诱导输入账号密码。',
  },
  {
    icon: 'ri-search-eye-line',
    title: '核对域名与页面细节',
    desc: '观察域名写法、备案信息与页面文案是否规范，错别字、拼凑的域名往往是仿冒信号。',
  },
];

export const faqCategories = [
  { id: 'all', label: '全部' },
  { id: 'entry', label: '入口与地址' },
  { id: 'download', label: '下载与安装' },
  { id: 'use', label: '使用问题' },
  { id: 'about', label: '关于本站' },
];

export const faqs = [
  {
    id: 'f1',
    category: 'entry',
    q: '中文在线字幕官网入口应该去哪里找？',
    a: '建议优先通过官方公告、官方客户端内跳转等可信渠道确认入口。本页的官方入口分区整理了寻找入口的思路与注意事项，可作为参考，但最终请以官方发布的信息为准。',
  },
  {
    id: 'f2',
    category: 'entry',
    q: '为什么有时候页面打不开？',
    a: '页面打不开通常与地址调整、访问高峰期或本地网络环境有关。可以依次尝试刷新页面、更换网络、稍后再试；若持续无法访问，再到官方公告或本页更新记录中核对当前有效地址。',
  },
  {
    id: 'f3',
    category: 'entry',
    q: '最新地址多久更新一次？',
    a: '没有固定周期，会根据官方公告与页面可用情况随时复核。每次复核结果都会记录在页面的更新记录分区中，并标注对应日期，方便你判断信息的时效。',
  },
  {
    id: 'f4',
    category: 'download',
    q: 'App 可以在哪些设备上使用？',
    a: '常见形态包括安卓手机与平板、iPhone 与 iPad，以及电脑端网页版或桌面客户端。不同设备的获取方式略有差异，可在下载方式分区按设备查看对应说明。',
  },
  {
    id: 'f5',
    category: 'download',
    q: '一定要下载 App 吗？',
    a: '不一定。若只是偶尔使用，直接在浏览器访问网页版即可；如果希望获得离线缓存、多端同步等更完整的体验，再安装对应客户端。',
  },
  {
    id: 'f6',
    category: 'use',
    q: '使用需要注册账号吗？',
    a: '浏览部分内容可能无需登录，但多端同步观看进度、管理观看记录等功能通常需要登录账号。具体以平台内的实际提示为准。',
  },
  {
    id: 'f7',
    category: 'use',
    q: '字幕太小或者显示不完整怎么办？',
    a: '可以在播放界面打开字幕设置，调整字号、颜色与显示位置；若出现遮挡，可尝试切换全屏模式或修改字幕边距。轻微不同步时，也可手动微调字幕偏移。',
  },
  {
    id: 'f8',
    category: 'about',
    q: '本站和官方是什么关系？',
    a: '本站是一个以信息整理为目的的说明页面，聚合官方入口、最新地址与下载方式的获取思路，并非官方运营。所有功能与内容均以官方平台的实际提供为准。',
  },
];

export const changelog = [
  {
    date: '2026-10-10',
    version: '入口复核',
    content: '复核官方入口与下载方式的说明，更新常见问题中的下载与安装条目。',
  },
  {
    date: '2026-09-22',
    version: '内容完善',
    content: '补充「安全提示」分区，新增关于仿冒页面与未知安装包的风险说明。',
  },
  {
    date: '2026-08-30',
    version: '功能梳理',
    content: '整理多语言字幕、字幕样式自定义与多端同步等功能介绍，按能力分组展示。',
  },
  {
    date: '2026-08-05',
    version: '新增指南',
    content: '新增「使用指南」四步流程，帮助第一次接触平台的用户快速上手。',
  },
  {
    date: '2026-07-18',
    version: '页面上线',
    content: '页面首次上线，聚合官方平台入口、最新地址与 App 下载方式说明。',
  },
];